module.exports = "/fonts/nucleo-icons.ttf?b0dc05d015e91e7d28d79cd0056fe555";